import axios from "axios";
import { useUserStore } from "../store/useUserStore";

let getToken: (() => Promise<string | undefined>) | null = null;

export const setTokenGetter = (fn: () => Promise<string | undefined>) => {
  getToken = fn;
};

const api = axios.create({
  baseURL: process.env.REACT_APP_API_SERVER_URL,
  timeout: 100000,
});

api.interceptors.request.use(
  async (config) => {
    if (getToken) {
      const token = await getToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// The admin may have been deactivated on the api while the persisted userInfo
// still says isAdmin, which left pages stuck on a loader and firing errors.
// Dropping the session makes ProtectedRoute send the user to the unauthorized
// page instead.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;

    if (status === 401 || status === 403) {
      useUserStore.getState().clear();
    }

    return Promise.reject(error);
  }
);

export default api;
